import type { QiraMessageContentChunk } from 'api3';
import { CommonModule } from '@angular/common';
import { Component, HostBinding, computed, input } from '@angular/core';
import { ImageZoomDirective } from '@app/components/zoom/image-zoom-directive/image-zoom.directive';
import { MarkdownModule } from 'ngx-markdown';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-message-content-text',
  templateUrl: './message-content-text.component.html',
  styleUrls: [],
  imports: [MarkdownModule, CommonModule, MessageModule, ImageZoomDirective],
  standalone: true,
})
export class MessageContentTextComponent {
  content = input<QiraMessageContentChunk | undefined>();
  protected isLlmAnswer = computed(() => {
    return (this.content()?.answerType ?? ('' as string)) === 'llm_answer';
  });
  protected isInfoMessage = computed(() => {
    return (this.content()?.answerType ?? ('' as string)) === 'info_message';
  });

  @HostBinding('class.hidden')
  get isHidden(): boolean {
    return !this.content()?.text;
  }
}
